import React, { useEffect, useState } from "react";
import { fetchContent } from "../../services/api";
import { updateContent, extractErrorMessage } from "../../services/adminApi";
import { DEFAULT_CONTENT } from "../../data/contentDefaults";
import { TextField, TextAreaField, SaveBar } from "../FormControls";

const AboutEditor = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [savedAt, setSavedAt] = useState(null);

    useEffect(() => {
        fetchContent()
            .then((content) =>
                setData(content?.about || DEFAULT_CONTENT.about)
            )
            .catch(() => setData(DEFAULT_CONTENT.about))
            .finally(() => setLoading(false));
    }, []);

    const patch = (fields) => {
        setData((prev) => ({ ...prev, ...fields }));
        setSavedAt(null);
    };

    const patchFeature = (index, fields) => {
        setData((prev) => {
            const features = prev.features.slice();
            features[index] = { ...features[index], ...fields };
            return { ...prev, features };
        });
        setSavedAt(null);
    };

    const addFeature = () => {
        setData((prev) => ({
            ...prev,
            features: [...prev.features, { title: "", description: "" }],
        }));
    };

    const removeFeature = (index) => {
        setData((prev) => ({
            ...prev,
            features: prev.features.filter((_, i) => i !== index),
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const saved = await updateContent("about", data);
            setData(saved);
            setSavedAt(Date.now());
        } catch (err) {
            setError(extractErrorMessage(err, "Не удалось сохранить"));
        } finally {
            setSaving(false);
        }
    };

    if (loading || !data) return <p>Загрузка…</p>;

    return (
        <div className="admin-section">
            <h2 className="admin-section-title">О проекте</h2>

            <TextField
                label="Заголовок"
                value={data.title}
                onChange={(v) => patch({ title: v })}
            />
            <TextField
                label="Подзаголовок"
                value={data.subtitle}
                onChange={(v) => patch({ subtitle: v })}
            />
            <TextAreaField
                label="Описание"
                value={data.description}
                onChange={(v) => patch({ description: v })}
                rows={4}
            />
            <TextField
                label="Заголовок карточки схемы"
                value={data.heroCardTitle}
                onChange={(v) => patch({ heroCardTitle: v })}
            />
            <TextField
                label="Подпись под схемой"
                value={data.co2Caption}
                onChange={(v) => patch({ co2Caption: v })}
            />
            <TextField
                label="Заголовок блока «Возможности»"
                value={data.featuresTitle}
                onChange={(v) => patch({ featuresTitle: v })}
            />

            <h3 className="admin-subsection-title">Карточки возможностей</h3>
            {data.features.map((feature, i) => (
                <div className="admin-repeatable-item" key={i}>
                    <div className="admin-repeatable-header">
                        <span>Карточка {i + 1}</span>
                        <button
                            type="button"
                            className="admin-remove-button"
                            onClick={() => removeFeature(i)}
                        >
                            Удалить
                        </button>
                    </div>
                    <TextField
                        label="Заголовок"
                        value={feature.title}
                        onChange={(v) => patchFeature(i, { title: v })}
                    />
                    <TextAreaField
                        label="Описание"
                        value={feature.description}
                        onChange={(v) => patchFeature(i, { description: v })}
                        rows={2}
                    />
                </div>
            ))}
            <button
                type="button"
                className="admin-add-button"
                onClick={addFeature}
            >
                + Добавить карточку
            </button>

            <SaveBar
                onSave={handleSave}
                saving={saving}
                savedAt={savedAt}
                error={error}
            />
        </div>
    );
};

export default AboutEditor;
